import SelfVideo from './SelfVideo';

export default SelfVideo;
